import template from "./empty.html";
import "./empty.scss";

const emptyComponent = {
	template
};

export default emptyComponent;


// WEBPACK FOOTER //
// ./sources/utility/empty/empty.component.js